var module = angular.module('octopusApp.projects');

module.controller("ProjectLifecycleSelectorDialogController", function($scope, $injector, pluginRegistry, projectId, $uibModalInstance, busy, octopusRepository) {
  var isLoading = $scope.isLoading = busy.create();
  var isPreviewing = $scope.isPreviewing = busy.create();
  var isSaving = $scope.isSaving = busy.create();

  isLoading.promise(octopusRepository.Projects.get(projectId).then(function (project) {
    isLoading.promise(octopusRepository.Environments.all().then(function (environments) {
      isLoading.promise(octopusRepository.Lifecycles.all().then(function (lifecycles) {
        $scope.lifecycles = lifecycles;
        $scope.environments = environments;
        $scope.project = project;
        $scope.lifecyclesById = _.object(_.pluck(lifecycles, "Id"), lifecycles);

        $scope.preview();
      }));
    }));
  }));

  $scope.preview = function() {
    var selected = $scope.lifecyclesById[$scope.project.LifecycleId];

    isPreviewing.promise(octopusRepository.Lifecycles.preview(selected).then(function (previewLifecycle) {
      $scope.previewLifecycle = previewLifecycle;
    }));
  };

  $scope.accept = function() {
    isSaving.promise(octopusRepository.Projects.modify($scope.project).then(function (p) {
      $uibModalInstance.close(true);
    }));
  };
  $scope.close = function() {
    $uibModalInstance.close();
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/controllers/project_lifecycle_selector_dialog_controller.js
// module id = 517
// module chunks = 1